// @flow
import { connect } from 'react-redux';

import RencontreGeneralResult, { type StateProps } from 'components/rencontre/general/RencontreGeneralResult';

import type { StateType } from 'types/Actions';

const mapStateFromProps = (state: StateType): StateProps => ({
  rencontre: state.rencontreState.rencontre,
});

export default connect(mapStateFromProps)(RencontreGeneralResult);
